<nav>
  <div class="flex items-center justify-between gap-4 px-4 py-3 sm:px-6">
    <a
      routerLink="/numerons/latest"
      class="inline-flex items-center rounded-lg px-1 py-1"
      aria-label="Numerical home"
    >
      <img src="/assets/numerical-logo.png" alt="Numerical" class="h-10 w-auto sm:h-12" />
    </a>

    <div class="flex items-center gap-2 sm:gap-3">
      @if (authStateService.isAuthenticated()) {
        <span class="hidden text-sm font-medium text-text sm:inline-block">
          {{ authStateService.authUser()?.displayName }}
        </span>
        <button
          type="button"
          class="hidden rounded-lg border border-subtle px-3 py-2 text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted sm:inline-flex"
          (click)="signOut()"
        >
          Sign Out
        </button>
      } @else {
        <a
          routerLink="/signin"
          class="hidden rounded-lg border border-subtle px-3 py-2 text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted sm:inline-flex"
        >
          Sign In
        </a>
      }

      @if (!authStateService.isAuthenticated()) {
        <button
          type="button"
          class="hidden rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-contrast transition-colors duration-200 ease-in-out hover:opacity-90 sm:inline-flex"
        >
          Join
        </button>
      }

      <button
        type="button"
        class="inline-flex rounded-lg border border-subtle bg-surface-muted p-2 text-text sm:hidden"
        [attr.aria-expanded]="isMobileMenuOpen()"
        aria-controls="mobile-nav-menu"
        aria-label="Toggle navigation menu"
        (click)="toggleMobileMenu()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          class="h-5 w-5"
        >
          <path d="M3 6h18M3 12h18M3 18h18" />
        </svg>
      </button>
    </div>
  </div>

  <div class="hidden bg-primary px-6 py-3 text-primary-contrast sm:block">
    <div class="flex items-center gap-6">
      <a routerLink="/numerons/search" class="inline-flex items-center text-sm font-medium">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          class="h-4 w-4"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </a>
      <a routerLink="/numerons/latest" class="text-sm font-medium">Latest</a>
      <a routerLink="/numerons/mostviewed" class="text-sm font-medium">Most Viewed</a>
      <a routerLink="/topics" class="text-sm font-medium">Topics</a>
      @if (authStateService.isAuthenticated()) {
        <div class="relative">
          <button
            type="button"
            class="inline-flex items-center gap-2 rounded-lg px-2 py-1 text-sm font-medium text-primary-contrast transition-colors duration-200 ease-in-out hover:bg-white/10"
            [attr.aria-expanded]="isDesktopMyNumericalOpen()"
            aria-controls="desktop-my-numerical-menu"
            (click)="toggleDesktopMyNumerical()"
          >
            My Numerical
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              class="h-4 w-4 transition-transform duration-200 ease-in-out"
              [class.rotate-180]="isDesktopMyNumericalOpen()"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          @if (isDesktopMyNumericalOpen()) {
            <div
              id="desktop-my-numerical-menu"
              class="absolute left-0 top-full z-10 mt-3 min-w-52 overflow-hidden rounded-xl border border-subtle bg-surface text-text shadow-lg"
            >
              <div class="grid p-2">
                <a
                  routerLink="/mynumerons"
                  (click)="closeDesktopMyNumerical()"
                  class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
                >
                  My Numerons
                </a>
                <a
                  routerLink="/mynumerons/collection/new"
                  (click)="closeDesktopMyNumerical()"
                  class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
                >
                  New Collection
                </a>
                <a
                  routerLink="/mynumerons/numeron/new"
                  (click)="closeDesktopMyNumerical()"
                  class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
                >
                  New Numeron
                </a>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (isMobileMenuOpen()) {
    <div
      id="mobile-nav-menu"
      class="grid gap-3 border-t border-subtle bg-surface-muted px-4 py-4 sm:hidden"
    >
      <a
        routerLink="/numerons/search"
        class="inline-flex items-center text-sm font-medium text-text"
        (click)="closeMobileMenu()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          class="h-4 w-4"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </a>
      <a
        routerLink="/numerons/latest"
        class="text-sm font-medium text-text"
        (click)="closeMobileMenu()"
        >Latest</a
      >
      <a
        routerLink="/numerons/mostviewed"
        class="text-sm font-medium text-text"
        (click)="closeMobileMenu()"
        >Most Viewed</a
      >
      <a routerLink="/topics" class="text-sm font-medium text-text" (click)="closeMobileMenu()"
        >Topics</a
      >
      @if (authStateService.isAuthenticated()) {
        <button
          type="button"
          class="inline-flex items-center justify-between text-sm font-medium text-text"
          [attr.aria-expanded]="isMobileMyNumericalOpen()"
          aria-controls="mobile-my-numerical-menu"
          (click)="toggleMobileMyNumerical()"
        >
          <span>My Numerical</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            class="h-4 w-4 transition-transform duration-200 ease-in-out"
            [class.rotate-180]="isMobileMyNumericalOpen()"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>
        @if (isMobileMyNumericalOpen()) {
          <div
            id="mobile-my-numerical-menu"
            class="grid gap-1 rounded-xl border border-subtle bg-surface px-2 py-2"
          >
            <a
              routerLink="/mynumerons"
              (click)="closeMobileMenu()"
              class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
            >
              My Numerons
            </a>
            <a
              routerLink="/mynumerons/collection/new"
              (click)="closeMobileMenu()"
              class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
            >
              New Collection
            </a>
            <a
              routerLink="/mynumerons/numeron/new"
              (click)="closeMobileMenu()"
              class="rounded-lg px-3 py-2 text-left text-sm font-medium text-text transition-colors duration-200 ease-in-out hover:bg-surface-muted"
            >
              New Numeron
            </a>
          </div>
        }
      }
      <div class="mt-2 grid grid-cols-2 gap-2">
        @if (authStateService.isAuthenticated()) {
          <p class="col-span-2 text-sm font-medium text-text">
            {{ authStateService.authUser()?.displayName }}
          </p>
          <button
            type="button"
            class="rounded-lg border border-subtle px-3 py-2 text-sm font-medium text-text"
            (click)="signOut()"
          >
            Sign Out
          </button>
        } @else {
          <a
            routerLink="/signin"
            class="rounded-lg border border-subtle px-3 py-2 text-center text-sm font-medium text-text"
            (click)="closeMobileMenu()"
          >
            Sign In
          </a>
        }
        @if (!authStateService.isAuthenticated()) {
          <button
            type="button"
            class="rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-contrast"
            (click)="closeMobileMenu()"
          >
            Join
          </button>
        }
      </div>
    </div>
  }
</nav>
